import {transform} from 'ol/proj';

import {EPSG3857, EPSG4326, generateDefinition} from './projection';

export {EPSG3857, EPSG4326, generateDefinition};

export default coordinate => transform(coordinate, EPSG3857, EPSG4326);
